import React from "react";

const WhatIsRVSection = () => {
  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-4 max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-8 text-center">
          What is Remote Viewing?
        </h2>
        <p className="text-lg text-muted-foreground leading-relaxed text-center">
          Remote viewing is a structured method for describing an unknown target before seeing it. 
          With RemoteViz, you receive a blind target, record your impressions, then compare them 
          to the reveal. It's a simple loop: perceive, document, review. Over time, you build a 
          personal log of sessions you can study and learn from.
        </p>
      </div>
    </section>
  );
};

export default WhatIsRVSection;
